
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrdersForFranchiseeDialog extends Serenity.EntityDialog<OrdersRow, any> {
        protected getFormKey() { return OrdersforFranchiseeForm.formKey; }
        protected getIdProperty() { return OrdersRow.idProperty; }
        protected getLocalTextPrefix() { return OrdersRow.localTextPrefix; }
        protected getNameProperty() { return OrdersRow.nameProperty; }
        protected getService() { return OrdersService.baseUrl; }
        protected getDeletePermission() { return OrdersRow.deletePermission; }
        protected getInsertPermission() { return OrdersRow.insertPermission; }
        protected getUpdatePermission() { return OrdersRow.updatePermission; }

        public form = new OrdersforFranchiseeForm(this.idPrefix);
        constructor() {
            super();
            if (this.isNew()) {
                this.form.EInvoiceTo.value = '1';
                this.form.EPaymentType.value = '2';
                this.form.EPaymentStatus.value = '2';
                this.form.ESourceType.value = '4';
                this.form.EOrderStatus.value = '1';
                this.form.InvoiceCompanyId.value = '1';

                /*
                this.form.OrderInstallments.getGridField().toggle(false);*/
            }/*
            else {
                this.form.OrderInstallments.getGridField().toggle(true);
            }*/
            var currentDate = new Date();
            this.form.OrderDate.value = currentDate.toISOString();
        }

        onSaveSuccess(response: any) {
            super.onSaveSuccess(response);
            this.form.OrderInstallments.getGridField().toggle(true);
        }

        getSaveState() {
            try {
                return $.toJSON(this.getSaveEntity());
            }
            catch (e) {
                return null;
            }
        }

       

        protected OpenWindowWithPostData(url, windowoption, name, params) {
            var form = document.createElement("form");
            form.setAttribute("method", "post");
            form.setAttribute("action", url);
            form.setAttribute("target", name);
            for (var i in params) {
                if (params.hasOwnProperty(i)) {
                    var input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = i;
                    input.value = params[i];
                    form.appendChild(input);
                }
            }
            document.body.appendChild(form);
            window.open(url, name, windowoption);
            form.submit();
            document.body.removeChild(form);
        }
    }
}